import type { ThreadStatusTone, ThreadSubjectType, ThreadTypeFilter } from 'types/interfaces/thread';

/**
 * The one place the inbox's type colors live (ticket Decision 7). Rows,
 * chips, pills and the rail all read from here.
 */
export interface ThreadTypeStyle {
  /** Foreground: left bar, chip text. */
  color: string;
  /** Chip background. */
  background: string;
}

export const THREAD_TYPE_STYLES: Record<ThreadSubjectType, ThreadTypeStyle> = {
  TRADE: { color: '#60a5fa', background: 'rgba(59, 130, 246, 0.15)' },
  OFFER: { color: '#f5e2be', background: 'rgba(245, 226, 190, 0.12)' },
  CASE: { color: '#fb923c', background: 'rgba(251, 146, 60, 0.15)' },
  DIRECT: { color: '#a78bfa', background: 'rgba(111, 81, 228, 0.22)' },
  SYSTEM: { color: '#94a3b8', background: 'rgba(148, 163, 184, 0.15)' },
};

export const THREAD_TYPE_LABELS: Record<ThreadSubjectType, string> = {
  TRADE: 'Trade',
  OFFER: 'Offer',
  CASE: 'Case',
  DIRECT: 'Direct',
  SYSTEM: 'System',
};

/** Pill order above the list and the `type` param each sends. */
export const THREAD_TYPE_FILTERS: ReadonlyArray<{ value: ThreadTypeFilter; label: string; subjectType: ThreadSubjectType | null }> = [
  { value: 'all', label: 'All', subjectType: null },
  { value: 'trade', label: 'Trades', subjectType: 'TRADE' },
  { value: 'offer', label: 'Offers', subjectType: 'OFFER' },
  { value: 'case', label: 'Cases', subjectType: 'CASE' },
  { value: 'direct', label: 'Direct', subjectType: 'DIRECT' },
  { value: 'system', label: 'System', subjectType: 'SYSTEM' },
];

/** A row with no subjectType (legacy cache, older backend) renders as DIRECT. */
export const subjectTypeOf = (row: { subjectType?: ThreadSubjectType }): ThreadSubjectType =>
  row.subjectType ?? 'DIRECT';

/**
 * Status chip tones map onto the existing case status badge classes, which
 * moved from CasesPage.css into styles/caseStatusBadges.css so every surface
 * shares one source (ticket Decision 7: reuse the case status colors).
 */
export const STATUS_TONE_CLASS: Record<ThreadStatusTone, string> = {
  red: 'status-unread',
  blue: 'status-read',
  orange: 'status-in-progress',
  green: 'status-resolved',
  grey: 'status-closed',
  purple: 'status-purple',
};
